//Author F.R. Betancourt
import React, { useState, useEffect } from "react";
import { Button, Form, Icon, Grid } from "tabler-react";
import Select from "react-select";
import { Input } from "@mui/material";


const ContactosForm = ({
  stor,
  accion,
  elementos,
  getfuntion,
  cerrarModal,
}) => {


  
  const [formulario, setFormulario] = useState([]);
  const [nombre, setNombre] = useState();
  const [correo, setCorreo] = useState();
  const [telefono, setTelefono] = useState();
  const [id,setId] = useState();
  const [crudbutonEnable, setCrudbutonEnable] = useState(true); // Se desabilita cuando se hace click
  const [selectLocalidades, setSelectLocalidades] = useState(true);
  const [localidadesOpcion, setLocalidadesOpcion] = useState();
  const [localidadesOpciones, setLocalidadesOpciones] = useState();
  const [estatus, setEstatus] = useState();
  var currentUser = JSON.parse(sessionStorage.getItem("currentUser"));

  useEffect(() => {

    if (accion === "nuevo") {

      let localidadesOpcionesTemp = [];
      Object.keys(stor.localidades_object).forEach((key) => localidadesOpcionesTemp.push({ value: stor.localidades_object[key].id, label: stor.localidades_object[key].nombre}));

      setLocalidadesOpciones(localidadesOpcionesTemp)
    } else {
      setId(elementos.id)
      setCorreo(elementos.correo)
      setTelefono(elementos.telefono)
      setNombre(elementos.nombreCompleto)
      setEstatus(elementos.estatus)

      let localidadesOpcionesTemp = [];
      let selectedOpcion = [];
      Object.keys(stor.localidades_object).forEach((key) => {
        localidadesOpcionesTemp.push({ value: stor.localidades_object[key].id, label: stor.localidades_object[key].nombre})
        if(stor.localidades_object[key].id == elementos.idLocalidad.id){
         selectedOpcion.push({ value: stor.localidades_object[key].id, label: stor.localidades_object[key].nombre})
        }
        
    });
      setLocalidadesOpciones(localidadesOpcionesTemp)
      setLocalidadesOpcion(selectedOpcion)
      setFormulario(elementos);
    }
  }, []);


  const handleChangeOptions = (event=null,data=null)=>{

    let arrayFiltersTemp;
    let selectOption;

    if((event&& event.action === "select-option")){
      selectOption = event.name;
      arrayFiltersTemp = [{"name": selectOption,"value": event.option.value}];

      setSelectLocalidades(arrayFiltersTemp);
    }

    
  }



  const isEnable = (Accion) => {
    let borrar = "contactos_borrar";
    let actualizar = "contactos_editar";
    let agregar = "contactos_agregar";
    var privilegios = stor.privilegios_object;
    var perfil = JSON.parse(sessionStorage.getItem("perfil"));
    for (let i = 0; i < privilegios.length; i++) {
      if (Accion === "borrar") {
        if (privilegios[i].clave == borrar) {
          if (
            perfil.privilegios.filter(
              (word) => word.idPrivilegio == privilegios[i].id
            ).length > 0
          ) {
            return true;
          }
        }
      }
      if (Accion === "actualizar") {
        if (privilegios[i].clave == actualizar) {
          if (
            perfil.privilegios.filter(
              (word) => word.idPrivilegio == privilegios[i].id
            ).length > 0
          ) {
            return true;
          }
        }
      }
      if (Accion === "agregar") {
        if (privilegios[i].clave == agregar) {
          if (
            perfil.privilegios.filter(
              (word) => word.idPrivilegio == privilegios[i].id
            ).length > 0
          ) {
            return true;
          }
        }
      }
    }
    return false;
  };

  const enableSave = () => {
    if (localidadesOpcion ? (localidadesOpcion.length > 0  ? true : false) : false) {
      return false;
    } else {
      return true;
    }
  };

  const guardarLocalidades = async () => {
    if (accion === "modificar") {
      await crud_put();
    } else {
      await crud_post();
    }
  };

  const crud_delete = () => {
    setCrudbutonEnable(false);
    getfuntion("delete", "", elementos.id);
  };

  const crud_put = async () => {
    setCrudbutonEnable(false);
    let formulario =({id:id, idPlataforma: 1,nombreCompleto: nombre, idLocalidad: {id:localidadesOpcion[0].value,nombre:localidadesOpcion[0].label} , estatus: estatus ? estatus:false,telefono: telefono,correo:correo})
    
    await getfuntion("put", formulario);
    // Recargar el catálogo después de actualizar
    await getfuntion("get", [], "", [], "localidadesCorreosTransportistas");
    cerrarModal();
  };
  const crud_post = async () => {
   
    localidadesOpcion.map((localidad) =>{
      formulario.push({ idPlataforma: 1,nombreCompleto: nombre, idLocalidad: {id:localidad.value , nombre:localidad.label}  , estatus: estatus ? estatus:false,telefono: telefono,correo:correo})
    })
    setCrudbutonEnable(false);
    await getfuntion("post", formulario);
    cerrarModal();
  };
  return (
    <div>
      {accion === "modificar" ? <h4> {nombre} </h4> : null}

      {accion === "modificar" ?  
        <div>
          <Grid.Row>
            <Grid.Col md={6}>
                <Form.Group label="Nombre">
                      <Form.Input name="name" value={nombre} onChange={(e)=>{ setNombre(e.target.value);}} />
              </Form.Group>
              
              
            </Grid.Col>

            <Grid.Col md={6}>
                  <Form.Group label="Correo">
                      <Form.Input name="correo" value={correo} onChange={(e)=>{ console.log(e.target.value); setCorreo(e.target.value);}} />
                  </Form.Group>
            </Grid.Col>

          </Grid.Row>


          <Grid.Row>

                <Grid.Col md={6}>
                    <Form.Group label="Telefono">
                        <Form.Input name="telefono" value={telefono} onChange={(e)=>{ setTelefono(e.target.value);}} />
                    </Form.Group>
              </Grid.Col>

              <Grid.Col md={6}>
                  <Form.Group label="Selecciona la Localidad">
                  <Select   name="localidades" value={localidadesOpcion} onChange={(e,a)=>{ setLocalidadesOpcion(e); handleChangeOptions(a); }} options={localidadesOpciones} />

                  </Form.Group>
              </Grid.Col>
          </Grid.Row>

        <Grid.Row>
          <Grid.Col md={3}>
          <Form.Switch
            name="estatus"
            label="Activo"
            checked={estatus}
            onChange={(e) => {
              setEstatus( e.target.checked );
            }}
          />
          </Grid.Col>

        </Grid.Row>
          
        </div>
        : 

<div>
        <Grid.Row>

          <Grid.Col md={6}>
              <Form.Group label="Nombre">
                    <Form.Input name="name" value={nombre} onChange={(e)=>{ setNombre(e.target.value);}} />
            </Form.Group>
            
            
          </Grid.Col>
  
          <Grid.Col md={6}>
                <Form.Group label="Correo">
                    <Form.Input name="correo" value={correo} onChange={(e)=>{ console.log(e.target.value); setCorreo(e.target.value);}} />
                </Form.Group>
          </Grid.Col>
  
        </Grid.Row>
  
  
        <Grid.Row>
  
            <Grid.Col md={6}>
                <Form.Group label="Telefono">
                    <Form.Input name="telefono" value={telefono} onChange={(e)=>{ setTelefono(e.target.value);}} />
                </Form.Group>
          </Grid.Col>
          
          <Grid.Col md={6}>
              <Form.Group label="Selecciona la Localidad">
              <Select  isMulti name="localidades" value={localidadesOpcion} onChange={(e,a)=>{ setLocalidadesOpcion(e); handleChangeOptions(a); }} options={localidadesOpciones} />

              </Form.Group>
          </Grid.Col>
        </Grid.Row>
       
       <Grid.Row>
        <Grid.Col md={3}>
          <Form.Switch
            name="estatus"
            label="Activo"
            checked={formulario.estatus}
            onChange={(e) => {
              setEstatus( e.target.checked );
            }}
          />
        </Grid.Col>
     
      </Grid.Row></div>
}

      <div className="float-right">
        {isEnable("actualizar") || isEnable("agregar") ? (
          <span class="badge">
            <Button
              target="_blank"
              size="sm"
              RootComponent="a"
              color="primary"
              disabled={enableSave() || !crudbutonEnable}
              onClick={guardarLocalidades}
            >
              <span class="badge">
                <Icon link={true} name="save" />
                Guardar
              </span>
            </Button>
          </span>
        ) : null}
        {accion === "modificar" && isEnable("borrar") ? (
          <span class="badge">
            <Button
              target="_blank"
              size="sm"
              RootComponent="a"
              color="primary"
              onClick={() => crud_delete()}
              disabled={!crudbutonEnable}
            >
              <span class="badge">
                <Icon link={true} name="trash" />
                Borrar
              </span>
            </Button>
          </span>
        ) : null}
      </div>
    </div>
  );
};
export default ContactosForm;
